import { Component, ElementRef, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'; // Import Router for navigation
import { configuration } from 'src/configuration';
import { ApiServiceService } from '../service/api-service.service';
import { SharedService } from '../service/shared.service';

@Component({
  selector: 'app-reviews-view',
  templateUrl: './reviews-view.component.html',
  styleUrls: ['./reviews-view.component.css']
})
export class ReviewsViewComponent {
  review_id: string = '';
  reviewViewData: any = null;
  ratingFieldsList: any[] = [];
  isUserLoggedIn: boolean = false;
  reviewContent: string = '';


  ratingFieldsTemplate = [
    { field: 'location_convenience', label2: "Location Convenience", label: 'Location Convenience (AKA “How Far Is Civilization?”)', value: 0 },
    { field: 'curb_appeal', label2: "Curb Appeal", label: 'Curb Appeal (AKA “Is It Instagrammable?”)', value: 0 },
    { field: 'amenities', label2: "Amenities", label: 'Amenities (AKA “Is This a Resort or a Place to Live?”) ', value: 0 },
    { field: 'neighborhood_vibes', label2: "Neighborhood Vibes", label: 'Neighborhood Vibes (AKA “Will the Neighbors Borrow Sugar or Just Your Wi-Fi?”)', value: 0 },
    { field: 'greenery', label2: "Greenery", label: 'Greenery (AKA “How Much Lawn Is Too Much Lawn?”)', value: 0 },
    { field: 'construction', label2: "Construction Quality", label: 'Construction Quality (AKA “Will the ceiling fall on your head someday?”)', value: 0 },
    { field: 'investment_potential', label2: "Investment Potential", label: 'Investment Potential (AKA “Will This Place Make You a Property Tycoon?”)', value: 0 }
  ];

  allRating = [1,2,3,4,5]

  reviews = configuration.REVIEWS;
  
  constructor(
    public shared: SharedService, 
    private elRef: ElementRef, 
    private renderer: Renderer2, 
    public apiService: ApiServiceService,
    public route: ActivatedRoute,
    private router: Router 
  ) {
    this.shared.isWhiteMenu = true;
  }

  ngOnInit(): void {
    //this.isUserLoggedIn = this.shared.isUserLoggedIn;
    console.log('Login status on init:', this.isUserLoggedIn);
    this.review_id = this.route.snapshot.params['id'];
    
    // if (!this.review_id) {
    //   this.redirectToHome();
    // } else {
      this.getData();
      this.getApprovedReview();
    // }
  }

  
  async getData() {
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.GET_REVIEWS_BY_ID, {
      id: this.review_id
    });

    if (res && !res.error && res.data) {
      this.reviewViewData = res.data;
      
      this.ratingFieldsList = this.ratingFieldsTemplate.map(field => ({
        ...field,
        value: res.data[field.field] || 0 
      }));
      console.log("this.ratingFieldsList", this.ratingFieldsList);
    }
  }

  getStars(rating: number): number[] {
    return Array(rating).fill(0);  
  }

  // redirectToHome(): void {
  //   this.router.navigate(['/']); 
  // }

  async addReview() {
    console.log('Login status when submitting:', this.isUserLoggedIn);

    if (!this.shared.isUserLoggedIn) {
      alert('Please log in to submit your review.');
      return;
    }
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.ADD_USER_REVIEW, {
      review_id : this.review_id,
      review :this.reviewContent
    })
    if(res && !res.error && res.data){
      console.log("res.data", res.data)
      alert('Review submitted successfully!');
    }
    console.log('Review submitted successfully!');
  }
  async getApprovedReview() {
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.GET_APPROVED_REVIEW, {
      review_id: this.review_id
    });

    if (res && !res.error && res.data) {
      this.reviewViewData = res.data;

      const userIds = [...new Set(this.reviewViewData.map((review: any) => review.user_id))];

      let userRes = await this.apiService.POST_apiRequest(configuration.ENDPOINT.GET_USER_DATA, { user_ids: userIds });

      console.log('User Details API Response:', userRes);

      if (userRes && userRes.data) {
        const userNames = {};

        if (Array.isArray(userRes.data)) {
          userRes.data.forEach((user: any) => {
            userNames[user.id] = user.name;
          });
        } else {
          userNames[userRes.data.id] = userRes.data.name;
        }

        this.reviewViewData.forEach((review: any) => {
          review.username = userNames[review.user_id];
        });

        console.log('Approved Review:', this.reviewViewData);
      } else {
        console.error('API Response format is incorrect for user details:', userRes);
      }
    } else {
      console.error('Error fetching approved review:', res.error);
    }
  }  
}
